import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	isAiCostPressed: false,
	isOcsCostPressed: false,
	fobDecisionResponse: null
};

export const costingAgentSlice = createSlice({
	name: 'costingAgent',
	initialState,
	reducers: {
		setIsAiCostPressed: (state, { payload }) => {
			state.isAiCostPressed = payload;
		},
		setIsOcsCostPressed: (state, { payload }) => {
			state.isOcsCostPressed = payload;
		},
		setFobDecisionResponse: (state, { payload }) => {
			state.fobDecisionResponse = payload;
		}
	}
});
export const { setIsAiCostPressed, setIsOcsCostPressed, setFobDecisionResponse } = costingAgentSlice.actions;
export default costingAgentSlice.reducer;
